module.exports = __webpack_public_path__ + "static/media/dogenano-discord.fe49b80a.png";